import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ac00d5aa"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["href"]

import { ComputedRef, PropType, computed } from 'vue';
import { LinkIcon } from '@/enums/link-icon';
import { TranslateKey, useInject } from '@/composables/use-inject';
import AppIcon from '@/components/Base/AppIcon.vue';
import AppTooltip from '@/components/Base/AppTooltip.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'AppLinkIcon',
  props: {
  name: {
    type: String as PropType<LinkIcon>,
    required: true,
  },
},
  setup(__props) {

const props = __props;



const translate = useInject(TranslateKey);

const iconNameFileMap: ComputedRef<Record<LinkIcon, string>> = computed(
  (): Record<LinkIcon, string> => ({
    [LinkIcon.LEGAL]: 'legal.svg',
    [LinkIcon.GITHUB]: 'github.svg',
  }),
);

const iconNameLinkMap: ComputedRef<Record<LinkIcon, string>> = computed(
  (): Record<LinkIcon, string> => ({
    [LinkIcon.LEGAL]: '/legal',
    [LinkIcon.GITHUB]: 'https://github.com/sobekcore/blackdesertmarket',
  }),
);

const iconNameTooltipMap: ComputedRef<Record<LinkIcon, string>> = computed(
  (): Record<LinkIcon, string> => ({
    [LinkIcon.LEGAL]: translate('legal.legalTitle'),
    [LinkIcon.GITHUB]: 'GitHub',
  }),
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(AppTooltip, null, {
    popper: _withCtx(() => [
      _createTextVNode(_toDisplayString(_unref(iconNameTooltipMap)[props.name]), 1)
    ]),
    default: _withCtx(() => [
      _createElementVNode("a", {
        href: _unref(iconNameLinkMap)[props.name],
        target: "_blank"
      }, [
        _createVNode(AppIcon, {
          src: require(`@/assets/svg/${_unref(iconNameFileMap)[props.name]}`),
          class: "h-[24px]"
        }, null, 8, ["src"])
      ], 8, _hoisted_1)
    ]),
    _: 1
  }))
}
}

})